import * as React from "react";
import { ContextualMenu, DefaultButton, Dialog, DialogFooter, DialogType, hiddenContentStyle, mergeStyles, PrimaryButton, Toggle } from "@fluentui/react";
import { useId, useBoolean } from '@fluentui/react-hooks';
import App from '../App';

const dialogStyles = { main: { maxWidth: 450 } };
const dragOptions = {
  moveMenuItemText: 'Move',
  closeMenuItemText: 'Close',
  menu: ContextualMenu,
  keepInBounds: true,
};

const dialogContentProps = {
  type: DialogType.normal,
  title: 'File cannot be read',
  closeButtonAriaLabel: 'Close',
  subText: 'Template may be broken or inaccessible',
};

interface IDialogProps {
  isHidden: boolean;
  onDismiss: () => void;
  title: string;
  subText: string;
};

export const MessageDialog: React.FunctionComponent<IDialogProps> = (props) => {  
  const labelId: string = useId('dialogLabel');
  const subTextId: string = useId('subTextLabel');

  const contentProps = { ...dialogContentProps, ...props }

  const modalProps = React.useMemo(
    () => ({
      titleAriaId: labelId,
      subtitleAriaId: subTextId,
      isBlocking: false,
      styles: dialogStyles,
      dragOptions: dragOptions,
    }),
    [labelId, subTextId],
  );

  return (
    <Dialog
      hidden={props.isHidden}
      onDismiss={props.onDismiss}
      dialogContentProps={contentProps}
      modalProps={modalProps}
    >
      <DialogFooter>
        <DefaultButton onClick={props.onDismiss} text="Close" />
      </DialogFooter>
    </Dialog>
  );
};